import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import './assert/element-css/index.css';
//iconfont
import './assert/iconfont/iconfont.css'
import './assert/style/index.scss'
// utils
import '@/utils'
// api
import api from '@/api'
// 组件
import '@/components'
// 全局指令
import '@/directive'
import Vconsole from 'vconsole'

// const { href } = window.location
// if (href.includes('dev') || href.includes('uat') || href.includes('10.11')) { // 测试和开发打开，生产不能打开
//   let vConsole = new Vconsole()
// }
//复制到粘贴板插件
import VueClipboard from 'vue-clipboard2'
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)


Vue.config.productionTip = false;
Vue.use(ElementUI);


let vm = new Vue({
  router,
  store,
  render: h => h(App),
  mounted(){
      let oHtml = document.getElementsByTagName('html')[0];
      let oWidth = document.body.clientWidth || document.documentElement.clientWidth;
      oHtml.style.fontSize = oWidth / 7.5 + 'px';
  }
}).$mount('#app');

global.api = api;
global.vm = vm
